import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Typography,
} from "@mui/material";
import { RowRequestType } from "@/types/view"; // your type

interface DialogSelectFolderProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const DialogSelectFolder: React.FC<DialogSelectFolderProps> = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", mb: 2, textAlign: "center", fontSize: 24 }}>
        Chọn thư mục lưu trữ
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <Typography
              style={{
                fontWeight: 600,
                fontSize: 16,
                marginBottom: 4,
              }}
            >
              Chọn thư mục lưu trữ tệp tin trên hệ thống
            </Typography>
            <FormControl fullWidth>
              <Select size="small" labelId="label-type" value={"attachment"}>
                <MenuItem value={"attachment"}>:/Attachment</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={2} justifyContent="flex-end">
          <Grid item>
            <Button variant="contained" onClick={onSubmit}>
              Xác nhận
            </Button>
          </Grid>
          <Grid item>
            <Button variant="outlined" color="primary" onClick={onClose}>
              Đóng
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DialogSelectFolder;
